import { Card, Elevation } from "@blueprintjs/core";
import React, { Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import arrayUtils from '../../../utils/array';
import dateUtils from '../../../utils/date';
import numberUtils from '../../../utils/number';
import flatProfile from '../../assets/flatProfile.png';
import flatProfileTrans from '../../assets/flatProfileTrans.png';

class SearchResultCard extends React.Component {
    handleClick = () => {
        this.props.history.push({
            pathname: `/visitproperty/${this.props.data.uid}`
        });
    }

    render() {
        let inventoryType = this.props.data.inventoryType;
        if (inventoryType === 'Sell') {
            inventoryType = 'Sale'
        }
        let imgSrc = flatProfile;
        if (this.props.data.property.photos && this.props.data.property.photos.length) {
            imgSrc = this.props.data.property.photos[0].url || flatProfileTrans;
        }
        return (
            <Card className="search-card" elevation={Elevation.ONE}>
                <Link to={`/viewproperty/${this.props.data.uid}`} className="search-item">
                    <div className="columns main-details">
                        <div className="column">
                            <div className="is-size-4">{this.props.data.property.bedroomCount}BHK for {inventoryType}</div>
                            {
                                this.props.data.property.society ?
                                    <div className="is-size-5">
                                        {this.props.data.property.society.name}
                                        {this.props.data.property.society.address ?
                                            `, ${this.props.data.property.society.address}`
                                            : ''
                                        }
                                    </div>
                                    : null
                            }
                        </div>
                        <div className="column is-narrow cost-details">
                            <div className="is-size-4">{inventoryType === 'Sale' ? numberUtils.intoReadableAmount(this.props.data.sellPrice) : numberUtils.intoReadableAmount(this.props.data.leaseMonthlyRentAmount)}</div>
                            {
                                this.props.data.isNegotiable ?
                                    <div className="is-size-5">(Negotiable)</div> : null
                            }
                        </div>
                    </div>
                </Link>
                <div className="columns">
                    <Link to={`/viewproperty/${this.props.data.uid}`} className="search-item">
                        <div className="column is-narrow">
                            <div style={{ position: "relative" }}>
                                <img src={imgSrc} alt="" className="prop-img" style={{ display: "block" }} />
                                {this.props.data.property.photos.length ?
                                    <div className="available-photo">{this.props.data.property.photos.length} Photos Available</div>
                                    : null}
                            </div>
                        </div>
                    </Link>
                    <div className="column">
                        <div className="columns is-mobile is-multiline more-details has-text-grey-dark">
                            <div className="column is-6">
                                <div className="is-size-6">
                                    <div className="d-flex has-text-grey-light">
                                        <i className="flaticon-ruler flat-icon" />
                                        <span>&nbsp;Super Built Up: {this.props.data.property.superBuiltupArea} Sq.Ft</span>
                                    </div>
                                </div>
                            </div>
                            <div className="column is-6">
                                <div className="is-size-6">
                                    <div className="d-flex has-text-grey-light">
                                        <i className="flaticon-parking flat-icon" />
                                        <span>&nbsp;Parking: {this.props.data.property.parkings.length ?
                                            arrayUtils.countObjects(this.props.data.property.parkings, "parkingType")
                                            : 'NA'
                                        }</span>
                                    </div>
                                </div>
                            </div>
                            <div className="column is-6">
                                <div className="is-size-6">
                                    {inventoryType === 'Rent' ?
                                        <Fragment>
                                            <div className="d-flex has-text-grey-light">
                                                <i className="flaticon-child flat-icon" />
                                                <span>&nbsp;Tenant: {this.props.data.customerPreference}</span>
                                            </div>
                                        </Fragment> :
                                        <Fragment>
                                            <div className="d-flex has-text-grey-light">
                                                <i className="flaticon-bed flat-icon" />
                                                <span>&nbsp;Bedrooms: {this.props.data.property.bedroomCount}</span>
                                            </div>
                                        </Fragment>
                                    }
                                </div>
                            </div>
                            <div className="column is-6">
                                <div className="is-size-6">
                                    {inventoryType === 'Rent' ?
                                        <Fragment>
                                            <div className="d-flex has-text-grey-light">
                                                <i className="flaticon-sofa flat-icon" />
                                                <span>&nbsp;Furnishing: {this.props.data.furnishType || 'NA'}</span>
                                            </div>
                                        </Fragment> :
                                        <Fragment>
                                            <div className="d-flex has-text-grey-light">
                                                <i className="flaticon-birthday flat-icon" />
                                                <span>&nbsp;Age: {
                                                    this.props.data.property.society.completionYear ?
                                                        dateUtils.calculateAge(this.props.data.property.society.completionYear)
                                                        : 'NA'
                                                }
                                                </span>
                                            </div>
                                        </Fragment>
                                    }
                                </div>
                            </div>
                            <div className="column is-6-desktop">
                                <Link
                                    to={`/visitproperty/${this.props.data.uid}`}
                                    className="bp3-button bp3-fill bp3-large bp3-intent-success"
                                    text="Visit Property"
                                >
                                    Visit Property
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        );
    }
}

export default withRouter(SearchResultCard);


// WEBPACK FOOTER //
// ./src/app/containers/searchResultCard/index.js